import { Injectable, OnInit } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class ConstantProvider implements OnInit {

    public API_URL: string;
    public PG_SIZE: number = 20;

    ngOnInit() {

    }

    constructor() {
        this.API_URL = "https://www.jaraguatenisclube.com.br/api";
    }
}


// WEBPACK FOOTER //
// ./src/providers/constants.ts